import {
  Feedback,
  SET_FEEDBACK_LIST,
  FeedbackActionType,
  FeedbackState,
} from '../types';

const initialState: FeedbackState = {
  feedbackList: [],
};

function FeedbackReducer(state = initialState, action: FeedbackActionType): FeedbackState {
  switch (action.type) {
    case SET_FEEDBACK_LIST:
      return { ...state, feedbackList: action.payload };
    default:
      return state;
  }
}

export default FeedbackReducer;
